import { Registry } from 'monaco-editor/esm/vs/platform/registry/common/platform.js';
class ExplorerFileContributionRegistry {
    constructor() {
        this.descriptors = [];
    }
    register(descriptor) {
        this.descriptors.push(descriptor);
    }
    create(insta, container, store) {
        return ( this.descriptors.map(d => {
            const i = d.create(insta, container);
            store.add(i);
            return i;
        }));
    }
}
const explorerFileContribRegistry = ( new ExplorerFileContributionRegistry());
Registry.add("workbench.registry.explorer.fileContributions" , explorerFileContribRegistry);
export { explorerFileContribRegistry };
